import React from 'react';

export default function Admin(){
    return (
        <div>
            <h1 className="h3 mb-4 text-gray-800">
                Bienvenido(a) Administrador!
            </h1>
        </div>
    )
}